import React from "react";
import PackagesDesktop from "./packagesDesktop/packagesDesktop";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";
import { inject, observer } from "mobx-react";
import { PackageId } from "../../../helpers/package";
import "./packages.scss";
import PackagesMobile from "./packagesMobile/packagesMobile";

interface PackagesProps {
    uiFlagsStore?: UiFlagsStore;
    refreshPackage: (packageId: PackageId) => void;
    disabledButtons: boolean;
    setErrorMessage: (errorMessage: string) => void;
}

@inject("uiFlagsStore")
@observer
export default class Packages extends React.Component<PackagesProps, any> {
    public render() {
        return (
            <div className="packages">
                {this.props.uiFlagsStore!.isMobileSizeForPackages ? this.renderMobilePackages() : this.renderDesktopPackages()}
            </div>
        );
    }

    private renderMobilePackages() {
        return (
            <PackagesMobile refreshPackage={this.props.refreshPackage}
                disabledButtons={this.props.disabledButtons}
                setErrorMessage={this.props.setErrorMessage}
            />
        );
    }

    private renderDesktopPackages() {
        return (
            <PackagesDesktop refreshPackage={this.props.refreshPackage}
                disabledButtons={this.props.disabledButtons}
                setErrorMessage={this.props.setErrorMessage}
            />
        );
    }

}
